module.exports = __webpack_public_path__ + "img/krisp.906c5cc5.svg";